<template>
  <!-- 用户管理-用户交易链接封禁 -->
  <div class="user_transaction_link-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="openBanLinkDialog"
            >添加封禁链接</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-input
            clearable
            v-model.trim="query.link"
            placeholder="请输入交易链接"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            style="width: 150px"
            clearable
            v-model.trim="query.user_id"
            placeholder="请输入用户ID"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="refreshUser"
            >刷新关联用户</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="id" label="记录id" align="center">
        </el-table-column>
        <el-table-column
          prop="link"
          label="交易链接"
          min-width="200px"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="user_id" label="关联用户" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.user_id ? row.user_id : "无" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.status === 1">已解封</el-tag>
            <el-tag type="danger" v-if="row.status === 2">封禁7天</el-tag>
            <el-tag type="danger" v-if="row.status === 3">封禁永久</el-tag>
            <el-tag type="danger" v-if="row.status === 4">封禁到月底</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column
          prop="ban_time"
          label="封禁时间"
          min-width="150px"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="unseal_time"
          label="上次解封时间"
          min-width="150px"
          align="center"
          sortable
        >
          <template slot-scope="{ row }">
            <span>{{ row.unseal_time ? row.unseal_time : "未解封" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-dropdown
              style="margin-left: 10px"
              @command="bannedEvent"
              v-if="row.status === 1"
            >
              <el-button type="danger">
                封禁<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ rowInfo: row, command: 2 }"
                  >7天</el-dropdown-item
                >
                <el-dropdown-item :command="{ rowInfo: row, command: 3 }"
                  >永久</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="success" @click="unlockEvents(row)" v-else
              >解封</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <AddBanLinkDialog
      :visible="addViaible"
      @close="addViaible = false"
      @refresh="getData"
    ></AddBanLinkDialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { patchData, postData, getApiData, patchApiData, postApiData, delApiData } from '@/http'
import AddBanLinkDialog from '@/components/user/user_transaction_link/AddBanLinkDialog.vue'

export default {
  name: 'user_transaction_link',
  components: {
    AddBanLinkDialog
  },
  data() {
    return {
      addViaible: false,//添加封禁链接
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
        link: undefined,//交易链接
        user_id: undefined,//用户id
      },
      dataList: undefined,//数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  watch: {
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      //获取列表数据
      this.loading = true
      let params = this.query
      getApiData('trade_link_banned', params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openBanLinkDialog() {
      //打开封禁弹窗
      this.addViaible = true
    },
    bannedEvent(commandInfo) {
      //封禁链接
      let params = {
        id: commandInfo.rowInfo.id,
        status: commandInfo.command
      }
      patchApiData(`trade_link_banned`, params)
        .then(res => {
          this.$message.success('封禁成功！')
          this.getData()//刷新数据
        })
        .finally(() => {
        })
    },
    unlockEvents(rowInfo) {
      //解封链接
      let params = {
        id: rowInfo.id,
        status: 1
      }
      patchApiData(`trade_link_banned`, params)
        .then(res => {
          this.$message.success('解封成功！')
          this.getData()//刷新数据
        })
        .finally(() => {
        })
    },
    refreshUser() {
      postApiData(`load_trade_link`)
        .then(res => {
          if (res.code) {
            this.$message.success(res.msg)
            this.getData()//刷新数据            
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
        })

    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.user_transaction_link-box {
  header {
  }

  .body-box {
  }
}
</style>